import { DateTime } from "luxon";

export const LOCAL_STORAGE_THEME_KEY = "materiahunter-dark-mode";

export type MinMax = {
    min: number,
    max: number
}

export type PublishState = "draft" | "live";

export function StringSortCompare(a: string, b: string, order: "asc" | "desc"): number {
    const aUpper = a.toUpperCase();
    const bUpper = b.toUpperCase();

    if (order === "asc") {
        return aUpper < bUpper
            ? -1
            : bUpper < aUpper
                ? 1
                : 0;
    }

    return bUpper < aUpper
        ? -1
        : aUpper < bUpper
            ? 1
            : 0;
}

export type IdChange = {
    id: string | undefined,
    source: "url" | "creation"
}

export function getDisplayDate(date: Date) {
    return date.toDateString();
}

export type Comparison<T> = {
    before: T,
    after: T
};

export type Checkable = {
    isChecked: boolean
}

export type Identifiable = {
    id: string
}

const SIZE_UNITS = ['byte', 'kilobyte', 'megabyte', 'gigabyte', 'terabyte', 'petabyte']
const BYTES_PER_KB = 1028


/**
 * Format bytes as human-readable text.
 *
 * @param sizeBytes Number of bytes.
 *
 * @return Formatted string.
 */
export function humanFileSize(sizeBytes: number | bigint): string {
    let size = Math.abs(Number(sizeBytes))

    let u = 0
    while (size >= BYTES_PER_KB && u < SIZE_UNITS.length - 1) {
        size /= BYTES_PER_KB
        ++u
    }

    return new Intl.NumberFormat([], {
        style: 'unit',
        unit: SIZE_UNITS[u],
        unitDisplay: 'short',
        maximumFractionDigits: 1,
    }).format(size)
}

export type ImageExtension = "jpg" | "png";
export const IMAGE_PATH_TYPES = ["images/news", "images/cards"] as const;
export type ImagePathType = typeof IMAGE_PATH_TYPES[number];

export type ImageUploadState = {
    isModalOpen: boolean,
    imageUrl: string,
    uploadPath: string | null,
    sizeString: string,
    size: number,
    extension: ImageExtension
}

export type ImageUploadStateV2 = {
    isOpen: boolean,
    conflict?: boolean,
    imageUrl: string,
    sizeString: string,
    size: number,

    type: ImagePathType,
    name: string,
    extension: ImageExtension
    path: string
}

export function getImagePath(props: {
    type: ImagePathType,
    name: string,
    extension: ImageExtension
}): string {
    return `${props.type}/${props.name}.${props.extension}`;
}